import { when } from 'mobx';
import { Runtime } from '../../Runtime';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { RuntimeScheduleNextState } from './RuntimeScheduleNextState';
import { RuntimeScheduleNextIdle } from './RuntimeScheduleNextIdle';
import { ScheduledTask } from './ScheduledTask';
import { RuntimeScheduleNextAnimationFrame } from './RuntimeScheduleNextAnimationFrame';
import { bound } from '../../../../utils/decorators/basic';

export class RuntimeScheduler {
  readonly parent: Runtime;

  constructor(parent) {
    this.parent = parent;
  }

  get runtime(): Runtime {
    return this.parent;
  }

  @memoize
  get nextState() {
    return new RuntimeScheduleNextState(this.runtime);
  }

  @memoize
  get nextIdle() {
    return new RuntimeScheduleNextIdle(this.runtime);
  }

  @memoize
  get nextAnimationFrame() {
    return new RuntimeScheduleNextAnimationFrame(this.runtime);
  }

  @bound
  async addToNextStateChange(action, options?: Partial<ScheduledTask> = {}): Promise<any> {
    return await this.nextState.addToNext(action, options);
  }

  @bound
  async addToNextIdleStateChange(action, options?: Partial<ScheduledTask> = {}): Promise<any> {
    return await this.nextIdle.addToNext(action, options);
  }

  @bound
  async scheduleIdleBackgroundTask(action, options?: Partial<ScheduledTask> = {}): Promise<any> {
    if (this.parent.isBrowserRuntime) {
      await when(() => this.parent.solidBrowserRuntime.app.appBoot.isInteractiveStable);
    }
    return await this.nextIdle.addToNext(() => this.addToNextIdleStateChange(action), options);
  }

  @bound
  async scheduleForAnimationFrame(action, options?: Partial<ScheduledTask> = {}): Promise<any> {
    return await this.nextAnimationFrame.addToNext(action, options);
  }
}
